import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import ProfileModal from "../Components/Modals/ProfileModal";

type Props = NativeStackScreenProps<RootStackParamList, "Profile">;

const ProfileScreen: React.FC<Props> = ({ navigation }) => {
  return <ProfileModal onClose={() => navigation.goBack()} />;
};

export default ProfileScreen;
